// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"453f2ef2","455":"c646a454","977":"ddeb784e"}[chunkId] + ".chunk.js";
};